import { Button } from "@heroui/react";

const HeroSection = () => {
	return (
		<div
			className="relative min-h-[35rem] max-h-[40rem] bg-green-800 overflow-hidden bg-cover bg-no-repeat"
			style={{ backgroundImage: "url('/ccr-hero-bg.jpg')" }}
		>
			<div className="size-full absolute top-0 left-0 text-white">
				<div className="h-full container mx-auto max-w-7xl p-5 xl:p-0">
					<div className="h-full w-full sm:3/4 md:2/3 lg:w-full flex flex-col justify-center">
						<div className="space-y-10">
							<h1 className="font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl">
								Unlocking the Potential of Climate Action: Transforming Goals
								into Reality
							</h1>
							<p className="text-base md:text-xl md:leading-relaxed">
								The Cambodia Carbon Registry serves as a cornerstone for
								transparency, trust, and high-integrity carbon projects,
								aligning seamlessly with global climate ambitions under the
								Paris Agreement. It also supports Cambodia’s Pentagonal Strategy
								and Circular Strategy on Environment. By embracing digital
								transformation and collaborating closely with partners like
								UNDP, we ensure robust tracking, verification, and recognition
								of carbon credits. This initiative fosters a thriving carbon
								market that drives sustainable development and secures a greener
								future for Cambodia.
							</p>
							<div className="flex items-center gap-10 text-md">
								<Button
									as="a"
									href="/user"
									color="primary"
									size="lg"
									className="w-40 font-semibold "
								>
									Get Started
								</Button>
								<Button
									as="a"
									href="/how-it-works"
									size="lg"
									className="w-40 font-semibold bg-transparent text-white"
								>
									Learn How It Works
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default HeroSection;
